<template>
  <vs-popup
    :title="getTitle()"
    :active.sync="showThisPopup"
    @close="handleClose"
    class="edit-booking-popup"
  >
    <editing-booking
      ref="editingBookingComponent"
      :venue-details="venueDetails"
      @booking-saved="handleBookingSaved"
      :editing-mode="EDITING_MODE.Update"
    />
  </vs-popup>
</template>

<script>
import "flatpickr/dist/flatpickr.css";
import _ from "lodash";
import EditingBooking, {
  EDITING_MODE,
} from "./components/EditingBooking/EditingBooking.vue";

export default {
  components: {
    EditingBooking,
  },
  props: {
    venueDetails: Object,
  },
  data() {
    return {
      EDITING_MODE,
      showThisPopup: false,
      booking: undefined,
      reservedTable: undefined,
      event: undefined,
    };
  },
  computed: {},
  methods: {
    getTitle() {
      if (!this.booking) return "Creating title...";

      let title = "Booking";
      if (this.booking.isRequest()) {
        title = "Request";
      }
      if (this.reservedTable) {
        title += ` of table ${this.reservedTable.name}`;
      }
      if (this.event) {
        title += ` for EVENT ${this.event.eventName}`;
      }
      return title;
    },
    async show(enhancedBooking) {
      this.$refs.editingBookingComponent.updateBooking(enhancedBooking);
      this.booking = enhancedBooking.booking;
      this.reservedTable = enhancedBooking.reservedTable;
      this.event = enhancedBooking.event;
      this.showThisPopup = true;
    },
    handleBookingSaved() {
      this.$emit("booking-updated");
      this.handleClose();
    },
    handleClose() {
      this.booking = undefined;
      this.reservedTable = undefined;
      this.$refs.editingBookingComponent.clear();
      this.showThisPopup = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.edit-booking-popup::v-deep .vs-popup {
  width: 1080px;

  .vs-popup--content {
    overflow: hidden;
  }
}
.booking-section {
  background: #f8f8f8;
}

.text-red {
  color: #aa0000;
}
.text-green {
  color: #00891b;
}
</style>
